import React from 'react';
import { Container } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/autoplay';

const SupportedBy: React.FC = () => {
  return (
    <Container className="mx-auto text-center" id="supportedBySec">
      <h3 className="supportedBy">Supported By</h3>

      {/* Desktop Carousel */}
      <div id="supportLogoDesktop">
        <Swiper
          modules={[Autoplay]}
          spaceBetween={10}
          slidesPerView={5}
          loop={true}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
          }}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            600: {
              slidesPerView: 3,
            },
            1000: {
              slidesPerView: 5,
            },
          }}
          className="owl-carousel owl-theme"
        >
          <SwiperSlide>
            <div className="item">
              <img className="mt-lg-4" src="/assets/images/WhatsDesign (3)/aws_img.png" alt="AWS" style={{ width: '180px', height: 'auto', maxWidth: '100%' }} />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="item">
              <img className="mt-lg-5" src="/assets/images/WhatsDesign (3)/Microsoft-for-Startups-scaled 1.png" alt="Microsoft for Startups" style={{ width: '180px', height: 'auto', maxWidth: '100%' }} />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="item">
              <img src="/assets/images/WhatsDesign (3)/images 1.png" alt="Partner 3" style={{ width: '180px', height: 'auto', maxWidth: '100%' }} />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="item">
              <img src="/assets/images/WhatsDesign (3)/1706540537405 1.png" alt="Partner 4" style={{ width: '180px', height: 'auto', maxWidth: '100%' }} />
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="item">
              <img src="/assets/images/WhatsDesign (3)/WhatsApp Image 2024-09-12 at 22.56.04_478b1005 1.png" alt="Partner 5" style={{ width: '180px', height: 'auto', maxWidth: '100%' }} />
            </div>
          </SwiperSlide>
        </Swiper>
      </div>

      {/* Mobile Static Layout */}
      <div id="supportLogoMobile">
        <div className="d-inline-flex" style={{ marginBottom: '20px' }}>
          <img className="item1" width="81px" height="51px" src="/assets/images/WhatsDesign (3)/images 1.png" alt="Partner 1" />
          <img className="item2" width="96px" height="51px" src="/assets/images/WhatsDesign (3)/WhatsApp Image 2024-09-12 at 22.56.04_478b1005 1.png" alt="Partner 2" />
          <img className="item3" width="100px" height="67px" src="/assets/images/WhatsDesign (3)/1706540537405 1.png" alt="Partner 3" />
        </div>
        <div className="d-inline-flex">
          <img className="mt-lg-4 item4" width="150px" height="47px" src="/assets/images/WhatsDesign (3)/aws_img.png" alt="AWS" />
          <img className="mt-lg-5 item5" width="134px" height="44px" src="/assets/images/WhatsDesign (3)/Microsoft-for-Startups-scaled 1.png" alt="Microsoft for Startups" />
        </div>
      </div>
    </Container>
  );
};

export default SupportedBy;
